import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../../components/marketing/Reveal";
import Breadcrumbs from "../../components/marketing/Breadcrumbs";
import { useSeo } from "../../components/marketing/Seo";
import { PRACTICES } from "../../data/marketing";

export default function PracticesPage() {
  useSeo({ title: "Practices", description: "Explore CLYMACO's five consulting practices across EPR, solid waste, bulk waste generators, circular economy and waste-focused CSR.", path: "/practices" });
  return (
    <main id="main" className="bg-parchment-base pt-36" data-testid="practices-page">
      <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-6">
        <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "Practices" }]} />
        <div className="max-w-3xl">
          <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-forest-primary">Our practices</div>
          <h1 className="mt-4 font-display text-5xl font-medium tracking-tight text-forest-deep sm:text-6xl">Expertise across the waste value chain.</h1>
          <p className="mt-5 text-lg leading-relaxed text-forest-deep/65">Five connected practices, each with a clear scope, practical deliverables and a technology layer where it adds continuity.</p>
        </div>
        <div className="mt-14 space-y-8">
          {PRACTICES.map((practice, index) => (
            <Reveal key={practice.slug} delay={index * 0.04}>
              <Link to={`/practice/${practice.slug}`} className="group grid overflow-hidden rounded-[2rem] border border-forest-deep/10 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-forest-deep/10 lg:grid-cols-[0.9fr_1.1fr]" data-testid={`practices-list-${practice.slug}`}>
                <div className="relative min-h-[280px] bg-forest-deep">
                  <img src={practice.image} alt={practice.imageCaption} className="absolute inset-0 h-full w-full object-cover opacity-85" loading={index > 1 ? "lazy" : "eager"} />
                  <span className="absolute left-5 top-5 rounded-full bg-black/30 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-white/85">{practice.imageCaption}</span>
                </div>
                <div className="p-7 sm:p-10">
                  <div className="flex items-start justify-between gap-4">
                    <span className="font-mono text-xs font-semibold text-forest-deep/40">{practice.num}</span>
                    <ArrowUpRight className="h-6 w-6 text-forest-primary transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>
                  <p className="mt-8 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-forest-primary">{practice.audience}</p>
                  <h2 className="mt-3 font-display text-3xl font-medium text-forest-deep sm:text-4xl">{practice.title}</h2>
                  <p className="mt-4 max-w-2xl text-base leading-relaxed text-forest-deep/65">{practice.summary}</p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {practice.points.map((point) => <span key={point} className="rounded-full bg-forest-deep/5 px-3 py-1.5 text-xs font-semibold text-forest-deep/65">{point}</span>)}
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
